exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._9jZB {\n  min-width: 200px;\n  max-width: 200px;\n  height: 100%;\n  padding-bottom: 1.5em;\n  padding-top: 3em;\n  background: -webkit-gradient(linear, left top, left bottom, from(#485460), to(#161616));\n  background: -webkit-linear-gradient(#485460, #161616);\n  background: -o-linear-gradient(#485460, #161616);\n  background: linear-gradient(#485460, #161616); }\n\n._1qLF {\n  padding: 0.6em;\n  margin-bottom: 0.75em;\n  font-size: 16px;\n  color: black;\n  margin-left: 3em; }\n", ""]);

// exports
exports.locals = {
	"container": "_9jZB",
	"links": "_1qLF"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"namedExport":true,"localIdentName":"[hash:base64:4]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"data":"@import /"variables/";","includePaths":["/app/src/styles"]}!./src/components/SideNav/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"namedExport":true,"localIdentName":"[hash:base64:4]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"data":"@import \"variables\";","includePaths":["/app/src/styles"]}!./src/components/SideNav/styles.scss
// module chunks = 0